import { render, staticRenderFns } from "./ProdutoModal.vue?vue&type=template&id=43f65e62&scoped=true"
import script from "./ProdutoModal.vue?vue&type=script&lang=js"
export * from "./ProdutoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f65e62",
  null
  
)

export default component.exports